import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import Header from './Header';
import Footer from './Footer';

const skipLinkStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -10000px;
  left: 0;
  width: 100%;
  height: 26px;
  font-size: 14px;
  font-weight: bold;
  text-decoration: underline;
  color: #484941 !important;
  background-color: white;
  &:focus {
    position: static;
    outline-offset: -3px;
  }
  @media (min-width: 992px) {
    height: 30px;
    font-size: 18px;
  }
`;

function PageWrapper({ children, className, builder, headerAltState }) {
  return (
    <div className={className}>
      <a className={skipLinkStyles} id="skip-link" href="#page-content">Jump to Content</a>
      <Header altState={headerAltState} builder={builder} />
      { children }
      <Footer builder={builder} />
    </div>
  );
}

PageWrapper.propTypes = {
  builder: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  headerAltState: PropTypes.bool,
};

PageWrapper.defaultProps = {
  className: undefined,
  headerAltState: false,
};

export default withData({
  builder: true,
})(PageWrapper);



// WEBPACK FOOTER //
// ./src/components/PageWrapper.js